/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
// styles
import injectSheet from 'react-jss';
import styles from 'material/form/field/textarea/textarea_styles';



/* ========== ~~~~~~~~~~ FORM : FIELD  : TEXT AREA : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const TextAreaField = (props) => {
	return (
		<textarea
			className={`textarea ${props.classes.textarea}`}
			type={props.type}
			name={props.name}
			readOnly={props.readOnly ? props.readOnly : false}
			placeholder={props.placeholder}
			onFocus={props.handleFocus}
			onBlur={props.handleBlur}
			onKeyDown={props.handleKeyDown}
			onChange={props.handleChange}
			value={props.defaultValue}
            disabled={props.disabled}
		/>
	);
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(TextAreaField);